import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from './input-field.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputPercentageComponent } from './input-percentage/input-percentage.component';

@NgModule({
  declarations: [InputFieldComponent, InputPercentageComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule],
  exports: [InputFieldComponent, InputPercentageComponent],
})
export class InputFieldModule {}
